import React from 'react';
import { Card, Skeleton } from 'antd';

const ProductCardSkeleton = () => {
    return (
        <Card
            className="product-card-unified pcu-card-body-no-padding"
            style={{ borderRadius: 14, overflow: 'hidden', border: '1px solid #f2f2f2' }}
        >
            <div style={{ height: 150, background: '#f8fafc', position: 'relative', overflow: 'hidden' }}>
                <Skeleton.Button active style={{ width: '100%', height: '100%', borderRadius: 0 }} />
            </div>
            <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <Skeleton active paragraph={false} title={{ width: '85%' }} style={{ margin: 0 }} />
                <Skeleton active paragraph={false} title={{ width: '55%' }} style={{ margin: 0 }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '6px' }}>
                    <Skeleton.Button active size="small" style={{ width: 55, height: 18, borderRadius: 4 }} />
                    <Skeleton.Button active size="small" style={{ width: 48, height: 26, borderRadius: 6 }} />
                </div>
            </div>
        </Card>
    );
};

export default ProductCardSkeleton;
